import { useState } from "react";
import AppError from "../../utils/AppError.js";
import getMessage from "../../utils/getMessage.js";
import { useNavigate } from "react-router-dom";
import "../../styles/auth/auth.css";
import { sendResetPasswordOtp } from "../../services/otp.service.js";
import AuthSubmitButton from "../../components/auth/AuthSubmitButton.jsx";
import EmailInput from "../../components/auth/EmailInput.jsx";
import ErrorText from "../../components/auth/ErrorText.jsx";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await sendResetPasswordOtp({ email });
      navigate("/reset-password-verify-otp", { state: { email } });
    } catch (error) {
      if (error instanceof AppError) {
        setError(error.message);
      } else {
        setError(getMessage("common", "error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="outer">
      <h1 className="auth-heading">Reset Password</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <ErrorText error={error} />
        <EmailInput email={email} setEmail={setEmail} loading={loading} />

        <AuthSubmitButton
          loading={loading}
          text="GET OTP"
          disabledText="Sending OTP..."
        />
      </form>
    </div>
  );
};

export default ResetPassword;
